export const LEAD_SESSION_KEY = 'mlarlive_lead';

export type LeadSession = {
	answers: Record<string, string>;
	thankYouUrl: string;
	token: string;
};

const isLeadSession = (value: unknown): value is LeadSession => {
	if (!value || typeof value !== 'object') return false;
	const session = value as LeadSession;
	return (
		typeof session.token === 'string' &&
		session.token !== '' &&
		typeof session.thankYouUrl === 'string' &&
		typeof session.answers === 'object' &&
		session.answers !== null
	);
};

export const getLeadSession = (): LeadSession | null => {
	try {
		const raw = localStorage.getItem(LEAD_SESSION_KEY);
		if (!raw) return null;
		const parsed: unknown = JSON.parse(raw);
		return isLeadSession(parsed) ? parsed : null;
	} catch {
		return null;
	}
};

export const setLeadSession = (session: LeadSession): void => {
	localStorage.setItem(LEAD_SESSION_KEY, JSON.stringify(session));
};

export const saveLeadAnswer = (key: string, answer: string): void => {
	const session = getLeadSession();
	if (!session || key === '') return;
	session.answers[key] = answer;
	setLeadSession(session);
};

export const gateLeadPages = (): void => {
	const session = getLeadSession();

	if (document.body.classList.contains('home')) {
		if (session?.token && session.thankYouUrl) {
			window.location.replace(session.thankYouUrl);
		}
		return;
	}

	if (!document.querySelector('[data-survey]')) return;
	if (session?.token) return;

	const home =
		document.querySelector<HTMLAnchorElement>('a[rel="home"]')?.href ?? '/';
	window.location.replace(home);
};
